import { useState, useEffect } from "react";

import EventStatus from "./EventStatus";

import { SLOT_HEIGHT, SLOT_TITLE_HEIGHT } from "../js/constants";

import moment from "moment";

export default ({ event, numEvent, numEvents, onClickEvent }) => {
  const CALENDAR_SLOT_WIDTH = 95;

  const [dateTime, setDateTime] = useState("");
  const [small, setSmall] = useState(false);

  //console.log("EVENT", event);

  useEffect(() => {
    if (event) {
      let small = false;
      if (event.timeStart === -1 || event.timeEnd === -1) {
        small = true;
      } else {
        const minutes = moment(event.timeEnd, "HH:mm:ss").diff(
          moment(event.timeStart, "HH:mm:ss"),
          "minutes",
        );

        small = minutes <= 30;
      }
      setSmall(small);

      // Datetime

      let dTime = "";
      if (event.timeStart !== -1) {
        // Evento con horas
        dTime = small
          ? moment(event.timeStart, "HH:mm:ss").format("HH:mm")
          : moment(event.timeStart, "HH:mm:ss").format("HH:mm") +
            " - " +
            moment(event.timeEnd, "HH:mm:ss").format("HH:mm");
      }
      setDateTime(dTime);
    }
  }, [event]);

  return (
    <div
      className={`event-card event-card-slot ${small ? "small" : ""}`}
      style={{
        position: event.timeStart === -1 ? "relative" : "absolute",
        width:
          event.timeStart === -1
            ? "100%"
            : CALENDAR_SLOT_WIDTH / numEvents + "%",
        left:
          event.timeStart === -1
            ? 0
            : (CALENDAR_SLOT_WIDTH / numEvents) * numEvent + "%",
        height:
          event.timeStart === -1
            ? SLOT_TITLE_HEIGHT
            : (moment(event.timeEnd, "HH:mm:ss").diff(
                moment(event.timeStart, "HH:mm:ss"),
                "minutes",
              ) /
                15) *
              SLOT_HEIGHT,
        backgroundColor: event.calendarColor,
      }}
      onClick={(e) => {
        e.stopPropagation();
        onClickEvent(event);
      }}
    >
      <div
        className="event-card-body"
        style={{ flexDirection: small ? "row" : "column" }}
      >
        {!small && (
          <>
            <span className="event-card-title">
              <EventStatus status={event.status} />
              <span className="event-card-title-text">{event.subject}</span>
            </span>
            {event.patient.id !== -1 && (
              <span>
                {event.patient.name} {event.patient.lastName}
              </span>
            )}
            <span>{dateTime}</span>
          </>
        )}
        {small && (
          <>
            <EventStatus status={event.status} />
            <span className="event-card-title-text">
              {event.subject}{" "}
              {event.patient.id !== -1
                ? `- ${event.patient.name} ${event.patient.lastName} `
                : ""}
              {event.timeStart !== -1 ? `- ${dateTime}` : ""}
            </span>
          </>
        )}
      </div>
    </div>
  );
};
